export default __webpack_public_path__ + "2dd06c487687d81f198e17d33de2d8ca.png";